// Тут описаны все настройки для всех элементов игры

import gameObjectTypes from '../gameObjectTypes';
import gameSettings from '../gameSettings';
import lootOptions from '../lootOptions';

export const roadSides = {
    RIGHT: 'right',
    LEFT: 'left'
};

const mirrorObjectSettingsToOtherRoadside = (settings) => ({
    ...settings,
    startPoint: {
        ...settings.startPoint,
        x: -1 * settings.startPoint.x
    },
    startPointPt: {
        ...settings.startPointPt,
        x: -1 * settings.startPointPt.x
    },
    endPoint: {
        ...settings.endPoint,
        x: -1 * settings.endPoint.x
    },
    endPointPt: {
        ...settings.endPointPt,
        x: -1 * settings.endPointPt.x
    },
    startPointRandomness: {
        minX: settings.startPointRandomness ? -1 * settings.startPointRandomness.minX : 0,
        maxX: settings.startPointRandomness ? -1 * settings.startPointRandomness.maxX : 0
    }
});

const ajacentObjectSpacingDefault = {
    min: 5,
    max: 12
};

const roadsideObjectDefaultSettings = {
    startPoint: {
        x: 150,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.3
    },
    startPointPt: {
        x: 150,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.3
    },
    endPoint: {
        x: 1300,
        y: 448,
        scale: 1.1
    },
    endPointPt: {
        x: 850,
        y: 400,
        scale: 1
    },
    addingPeriod: {
        from: 5,
        to: 10
    },
    spacingAfter: ajacentObjectSpacingDefault,
    scaleRandomness: {
        min: 1,
        max: 1.3
    },
    randomizeHorizontalReflection: true,
    startPointRandomness: {
        minX: 0,
        maxX: 120
    }
    // powRelativeFromScale: true
};

const curbstoneDefaultSettings = {
    startPoint: {
        x: 40,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.2
    },
    startPointPt: {
        x: 10,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.4
    },
    endPoint: {
        x: 870,
        y: 220,
        scale: 1.6
    },
    endPointPt: {
        x: 500,
        y: 150,
        scale: 1.1
    },
    addingPeriod: {
        from: 3,
        to: 3
    },
    ignoreOtherObjectsSpacing: true
};

const hummockDefaultSettings = {
    objectClasses: ['hummock'],
    spacePx: 100,
    ...roadsideObjectDefaultSettings
};

const rockDefaultSettings = {
    objectClasses: ['rock-1'],
    spacePx: 100,
    ...roadsideObjectDefaultSettings
};

const bushDefaultSettings = {
    objectClasses: ['bush-1'],
    spacePx: 100,
    ...roadsideObjectDefaultSettings,
    startPoint: {
        y: gameSettings.roadHeightPx - 8,
        ...roadsideObjectDefaultSettings.startPoint
    }
};

const signDefaultSettings = {
    objectClasses: ['sign'],
    spacePx: 100,
    addingPeriod: {
        from: 40,
        to: 50
    },
    startPoint: {
        x: 70,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.3
    },
    startPointPt: {
        x: 70,
        y: gameSettings.roadHeightPx - 2,
        scale: 0.4
    },
    endPoint: {
        x: 1000,
        y: 300,
        scale: 1.3
    },
    endPointPt: {
        x: 600,
        y: 300,
        scale: 1.2
    },
    spacingAfter: ajacentObjectSpacingDefault
};

const treeDefaultSettings = {
    objectClasses: ['tree'],
    spacePx: 100,
    ...roadsideObjectDefaultSettings
};

const largeTreeDefaultSettings = {
    spacePx: 100,
    ...roadsideObjectDefaultSettings,
    startPoint: {
        x: 120,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.25
    },
    endPoint: {
        x: 1350,
        y: 350,
        scale: 1.15
    },
    startPointPt: {
        ...roadsideObjectDefaultSettings.startPointPt,
        scale: 0.3
    },
    endPointPt: {
        ...roadsideObjectDefaultSettings.endPointPt,
        x: roadsideObjectDefaultSettings.endPointPt.x + 40,
        scale: 1
    }
};

const mooseDefaultSettings = {
    objectClasses: ['moose'],
    spacePx: 100,
    ...roadsideObjectDefaultSettings,
    addingPeriod: {
        from: 20,
        to: 30
    },
    scaleRandomness: null,
    randomizeHorizontalReflection: false
};

const regionBuildingDefaultSettings = {
    objectClasses: ['region-building'],
    spacePx: 100,
    addingPeriod: {
        from: 1,
        to: 1
    },
    startPoint: {
        x: 220,
        y: gameSettings.roadHeightPx - 4,
        scale: 0.25
    },
    startPointPt: {
        x: 300,
        y: gameSettings.roadHeightPx - 2,
        scale: 0.3
    },
    endPoint: {
        x: 1550,
        y: 500,
        scale: 1
    },
    endPointPt: {
        x: 1600,
        y: 300,
        scale: 1.3
    },
    spacingAfter: {
        min: 20,
        max: 20
    }
};

const regionSignDefaultSettings = {
    objectClasses: ['region-sign'],
    spacePx: 100,
    addingPeriod: {
        from: 1,
        to: 1
    },
    startPoint: {
        x: 120,
        y: gameSettings.roadHeightPx - 5,
        scale: 0.3
    },
    startPointPt: {
        x: 100,
        y: gameSettings.roadHeightPx,
        scale: 0.4
    },
    endPoint: {
        x: 1150,
        y: 400,
        scale: 1
    },
    endPointPt: {
        x: 850,
        y: 148,
        scale: 1
    },
    spacingAfter: {
        min: 3,
        max: 3
    },
    powRelativeFromScale: true
};

export default {
    [gameObjectTypes.HUMMOCK_1_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(hummockDefaultSettings),
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.HUMMOCK_1_RIGHT]: {
        ...hummockDefaultSettings,
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.BUSH_1_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(bushDefaultSettings),
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.BUSH_1_RIGHT]: {
        ...bushDefaultSettings,
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.BUSH_2_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(bushDefaultSettings),
        objectClasses: ['bush-2'],
        roadSide: roadSides.LEFT,
        scaleRandomness: null,
        randomizeHorizontalReflection: false
    },
    [gameObjectTypes.BUSH_2_RIGHT]: {
        ...bushDefaultSettings,
        objectClasses: ['bush-2'],
        roadSide: roadSides.RIGHT,
        scaleRandomness: null,
        randomizeHorizontalReflection: false
    },
    [gameObjectTypes.BUSH_3_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(bushDefaultSettings),
        objectClasses: ['bush-3'],
        roadSide: roadSides.LEFT,
        scaleRandomness: null,
        randomizeHorizontalReflection: false
    },
    [gameObjectTypes.BUSH_3_RIGHT]: {
        ...bushDefaultSettings,
        objectClasses: ['bush-3'],
        roadSide: roadSides.RIGHT,
        scaleRandomness: null,
        randomizeHorizontalReflection: false
    },
    [gameObjectTypes.SIGN_60_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(signDefaultSettings),
        objectClasses: ['sign', 'sign--60'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.SIGN_60_RIGHT]: {
        ...signDefaultSettings,
        objectClasses: ['sign', 'sign--60'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.SIGN_MOOSE_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(signDefaultSettings),
        objectClasses: ['sign', 'sign--moose'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.SIGN_MOOSE_RIGHT]: {
        ...signDefaultSettings,
        objectClasses: ['sign', 'sign--moose'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.SPRUCE_1_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(treeDefaultSettings),
        objectClasses: ['spruce-tree-1'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.SPRUCE_1_RIGHT]: {
        ...treeDefaultSettings,
        objectClasses: ['spruce-tree-1'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.SPRUCE_2_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(largeTreeDefaultSettings),
        objectClasses: ['spruce-tree-2'],
        roadSide: roadSides.LEFT,
        addingPeriod: {
            from: 15,
            to: 25
        }
    },
    [gameObjectTypes.SPRUCE_2_RIGHT]: {
        ...largeTreeDefaultSettings,
        objectClasses: ['spruce-tree-2'],
        roadSide: roadSides.RIGHT,
        addingPeriod: {
            from: 15,
            to: 25
        }
    },
    [gameObjectTypes.TREE_1_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(largeTreeDefaultSettings),
        objectClasses: ['tree-1'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.TREE_1_RIGHT]: {
        ...largeTreeDefaultSettings,
        objectClasses: ['tree-1'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.MOOSE_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(mooseDefaultSettings),
        objectClasses: ['moose', 'moose--left'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.MOOSE_RIGHT]: {
        ...mooseDefaultSettings,
        objectClasses: ['moose', 'moose--right'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.ROCK_1_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(rockDefaultSettings),
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.ROCK_1_RIGHT]: {
        ...rockDefaultSettings,
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.REGION_1_SIGN]: {
        ...regionSignDefaultSettings,
        objectClasses: ['region-1-sign'],
        roadSide: roadSides.RIGHT,
        startPoint: {
            ...regionSignDefaultSettings.startPoint
            // scale: 0.6
        }
    },
    [gameObjectTypes.REGION_1_BUILDING]: {
        ...regionBuildingDefaultSettings,
        objectClasses: ['region-1-building'],
        roadSide: roadSides.RIGHT
        // startPoint: {
        //     ...regionBuildingDefaultSettings.startPoint,
        //     scale: 0.6
        // },
        // startPointPt: {
        //     ...regionBuildingDefaultSettings.startPointPt,
        //     scale: 0.4
        // }
    },
    [gameObjectTypes.REGION_2_SIGN]: {
        ...mirrorObjectSettingsToOtherRoadside(regionSignDefaultSettings),
        objectClasses: ['region-2-sign'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.REGION_3_SIGN]: {
        ...regionSignDefaultSettings,
        objectClasses: ['region-3-sign'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.REGION_3_BUILDING]: {
        ...regionBuildingDefaultSettings,
        objectClasses: ['region-3-building'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.REGION_4_SIGN]: {
        ...mirrorObjectSettingsToOtherRoadside(regionSignDefaultSettings),
        objectClasses: ['region-4-sign'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.REGION_5_SIGN]: {
        ...regionSignDefaultSettings,
        objectClasses: ['region-5-sign'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.REGION_5_BUILDING]: {
        ...regionBuildingDefaultSettings,
        objectClasses: ['region-5-building'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.REGION_6_SIGN]: {
        ...mirrorObjectSettingsToOtherRoadside(regionSignDefaultSettings),
        objectClasses: ['region-6-sign'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.REGION_LAKE]: {
        startPoint: {
            x: -220,
            y: gameSettings.roadHeightPx - 10,
            scale: 0.3
        },
        startPointPt: {
            x: -250,
            y: gameSettings.roadHeightPx - 8,
            scale: 0.4
        },
        endPoint: {
            x: -2000,
            y: 448,
            scale: 1.3
        },
        endPointPt: {
            x: -1500,
            y: 260,
            scale: 1
        },
        addingPeriod: {
            from: 1,
            to: 1
        },
        spacingAfter: {
            min: 20,
            max: 20
        },
        objectClasses: ['region-lake'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.DIVIDE_LINE]: {
        objectClasses: ['divide-line'],
        objectClassOptions: ['divide-line--1', 'divide-line--2'],
        spacePx: 50,
        addingPeriod: {
            from: 2.4,
            to: 2.4
        },
        startPoint: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.1
        },
        startPointPt: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.1
        },
        endPoint: {
            x: 0,
            y: 0,
            scale: 1.3
        },
        endPointPt: {
            x: 0,
            y: 0,
            scale: 1.3
        },
        powRelativeFromScale: true,
        ignoreOtherObjectsSpacing: true
    },
    [gameObjectTypes.CURBSTONE_SEPARATOR_RIGHT]: {
        ...curbstoneDefaultSettings,
        objectClasses: ['curbstone-separator', 'curbstone-separator--right'],
        roadSide: roadSides.RIGHT
    },
    [gameObjectTypes.CURBSTONE_SEPARATOR_LEFT]: {
        ...mirrorObjectSettingsToOtherRoadside(curbstoneDefaultSettings),
        objectClasses: ['curbstone-separator', 'curbstone-separator--left'],
        roadSide: roadSides.LEFT
    },
    [gameObjectTypes.MAIN_CHARACTER]: {
        objectClasses: ['bus'],
        additionalElements: {
            baseClasses: ['bus__element'],
            elements: [
                {
                    id: 'bus-body',
                    neverHide: true,
                    classes: ['bus__body']
                },
                {
                    id: 'bus-wheels',
                    neverHide: true,
                    classes: ['bus__wheels']
                },
                {
                    id: 'bus-shadow',
                    neverHide: true,
                    classes: ['bus__shadow']
                },
                {
                    id: 'bus-vynil',
                    neverHide: true,
                    classes: ['bus__vynil'],
                    appendTo: 'bus-body'
                },
                {
                    id: 'bus-above-vynil-elements',
                    neverHide: true,
                    classes: ['bus__above-vynil-elements'],
                    appendTo: 'bus-body'
                },
                {
                    id: 'bus-protection-aura',
                    neverHide: true,
                    classes: ['bus__protection-aura']
                },
                {
                    id: lootOptions.PROTECTION_1,
                    hidden: true,
                    classes: ['bus__protection-decor-1'],
                    appendTo: 'bus-body'
                },
                {
                    id: lootOptions.PROTECTION_2,
                    hidden: true,
                    classes: ['bus__protection-decor-2'],
                    appendTo: 'bus-body'
                },
                {
                    id: lootOptions.PROTECTION_3,
                    hidden: true,
                    classes: ['bus__protection-decor-3'],
                    appendTo: 'bus-body'
                }
            ]
        },
        startPoint: {
            x: 250,
            y: 83
        },
        startPointPt: {
            x: 110,
            y: 190
        },
        maxOffsetByX: 8,
        maxOffsetByXPt: 4
    },
    [gameObjectTypes.LOOT_OBJECT]: {
        objectClasses: ['loot'],
        spacePx: 600,
        addingPeriod: {
            from: 10,
            to: 30
        },
        startPoint: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.2
        },
        startPointPt: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.3
        },
        endPoint: {
            x: 0,
            y: 0,
            scale: 1
        },
        endPointPt: {
            x: 0,
            y: 0,
            scale: 1
        },
        // в пикселях, потому что это влияет на endPoint, а он в пикселях
        maxOffsetByXPx: gameSettings.roadWidthPx * 0.3,
        maxOffsetByXPtPx: gameSettings.roadWidthPx * 0.15,
        powRelativeFromScale: true,
        // "ширина" объекта. Чем больше значения, тем проще в него врезаться
        spaceForIntersection: {
            x: 2
            // y: 2
        },
        spaceForIntersectionPt: {
            x: 1
            // y: 5
        }
    }
};
